import React, { useState, useEffect } from 'react';
import Modal from "react-bootstrap/Modal";


export default function Alert(props) {
    const [show, setShow] = useState();
    const [comment, setComment] = useState();

    const handleClose = (event) => {
        setShow(false);
        props.handler(false);
    };

    useEffect(() => {
        const fetchData = async () => {
            setShow(props.show);
            setComment(props.comment);
        };
        fetchData();
    }, [props.show]);
  
    return (
          <Modal show={show}>
            <Modal.Body>
                <p className="size17 text-center mt-15 bold" dangerouslySetInnerHTML={{ __html: comment }} ></p>
            </Modal.Body>
            <Modal.Footer>
                <div className="foot-btn">
                    <button type="button" className="btn primary" onClick={handleClose}>확인</button>
                </div>
            </Modal.Footer>
          </Modal>
    );
}